module.exports = __webpack_public_path__ + "img/热气球.90de8e48.png";